var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdersblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.39111H10",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.39111H10",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.3911H6",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.29111H12C12.6075 1.29111 13.1 1.7836 13.1 2.39111V9.40047C13.1866 9.39425 13.2736 9.39111 13.3609 9.39111H14V2.39111C14 1.28654 13.1046 0.391113 12 0.391113H2C0.895431 0.391113 0 1.28654 0 2.39111V12.3911C0 13.4957 0.89543 14.3911 2 14.3911H8.7386C8.54958 14.1136 8.43023 13.8061 8.37777 13.4911H2C1.39249 13.4911 0.9 12.9986 0.9 12.3911V2.39111C0.9 1.7836 1.39249 1.29111 2 1.29111Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9848 11.7438L15.1707 14.5405C15.1098 14.7397 14.95 14.8724 14.7598 14.8724H11.6174C11.4348 14.8724 11.2598 14.748 11.1989 14.5654L9.99674 11.055H9.30435C9.13696 11.055 9 10.9056 9 10.7231C9 10.5405 9.13696 10.3911 9.30435 10.3911H10.2098C10.3391 10.3911 10.4533 10.4824 10.4989 10.6152L11.7391 14.2085H14.6304L15.2772 11.9679H11.6935C11.5261 11.9679 11.3891 11.8185 11.3891 11.6359C11.3891 11.4534 11.5261 11.304 11.6935 11.304H15.6957C15.7946 11.304 15.8859 11.3621 15.9391 11.4451C16 11.528 16.0152 11.6442 15.9848 11.7438ZM11.7696 15.3123C11.6402 15.3123 11.5109 15.3704 11.4196 15.47C11.3283 15.5695 11.275 15.7106 11.275 15.8517C11.275 15.9928 11.3283 16.1339 11.4196 16.2334C11.5109 16.333 11.6402 16.3911 11.7696 16.3911C11.8989 16.3911 12.0283 16.333 12.1196 16.2334C12.2109 16.1339 12.2641 15.9928 12.2641 15.8517C12.2641 15.7106 12.2109 15.5695 12.1196 15.47C12.0283 15.3704 11.8989 15.3123 11.7696 15.3123ZM14.5011 15.3123C14.3717 15.3123 14.2424 15.3704 14.1511 15.47C14.0598 15.5695 14.0065 15.7106 14.0065 15.8517C14.0065 15.9928 14.0598 16.1339 14.1511 16.2334C14.2424 16.333 14.3717 16.3911 14.5011 16.3911C14.6304 16.3911 14.7598 16.333 14.8511 16.2334C14.9424 16.1339 14.9957 15.9928 14.9957 15.8517C14.9957 15.7106 14.9424 15.5695 14.8511 15.47C14.7598 15.3704 14.6304 15.3123 14.5011 15.3123Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersblack);
export default __webpack_public_path__ + "static/media/ordersblack.7dcc0fa1f1750087f604c20fff1ffdad.svg";
export { ForwardRef as ReactComponent };